import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import axios from 'axios';
import { computed, ref } from 'vue';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import router from '../../router';

interface Props {
  customer?: string | null;
}
interface CustomerSelect {
  label: string;
  value: string;
}
// プルダウン

export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerSelects',
  props: {
    customer: {}
  },
  emits: ["selected"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const customers = ref(computed(() => props.customer));
// Loading
const isLoading = ref(false);

const options = ref<CustomerSelect[]>([]);
// プルダウン（フィルター用）
const filterOptions = ref(options.value);

const emit = __emit;
const selected = (customer: string) => {
  emit('selected', customer);
};

/**
 * 得意先リスト取得
 */
const getCustmer = () => {
  // Loading Start
  isLoading.value = true;

  axios
    .post('/customers')
    .then((res) => {
      const { common, customerSelectItems } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          customerSelectItems.forEach(
            (customer: { customer_code: string; customer_name: string }) => {
              options.value.push({
                label: `${customer.customer_code}: ${customer.customer_name}`,
                value: customer.customer_code,
              });
            }
          );
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      isLoading.value = false;
    });
};

// プルダウンフィルター
const filterFn = (val: string, update: (arg0: () => void) => void) => {
  update(() => {
    if (val === '') {
      filterOptions.value = options.value;
    } else {
      const needle = val.toLowerCase();
      filterOptions.value = options.value.filter(
        (v: { label: string; value: string }) =>
          v.label.toLowerCase().indexOf(needle) > -1 || v.value.toLowerCase().indexOf(needle) > -1
      );
    }
  });
};

/**
 * 初期表示処理
 */

getCustmer();

return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, _mergeProps({
    modelValue: customers.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customers).value = $event)),
    outlined: "",
    options: filterOptions.value,
    loading: isLoading.value,
    "use-input": "",
    dense: "",
    "emit-value": "",
    "map-options": ""
  }, !customers.value && { placeholder: '選択してください' }, {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => selected(value)),
    onFilter: filterFn
  }), {
    "no-option": _withCtx(() => [
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "text-grey" }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("該当する得意先はありません")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["modelValue", "options", "loading"]))
}
}

})